module.exports = __webpack_public_path__ + "static/media/DIGITALIS-EXTIME-LOGOTYPE-2021-03.ce0afab0.png";